import React, { useEffect } from 'react';
import ListCourse from './courseList';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getAllCourses } from '../../redux/changeCourse/changeCourse.actions';

import Loader from '../../utils/Loader';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';

const mapDispatchToProps = (dispatch) => {
	return {
		getAllCourses: () => dispatch(getAllCourses()),
	};
};
const pathNAME = window.location.pathname

const ChangeCourse = ({
	history: { location: { pathname } } = {},
	getAllCourses,
}) => {
	useEffect(() => {
		Loader.show();
		getAllCourses();
	}, [getAllCourses]);
	return <ListCourse courseType={pathname} />;
};

export default compose(
	withRouter,
	connect(null, mapDispatchToProps),
	DefaultLayoutHOC,
)(ChangeCourse);
